import { Box, Typography, Skeleton, Stack, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

interface HeaderProps { title: string, breadcrumbs: {title:string, link:string}[], loading?: boolean}

export const Header = (props: HeaderProps) => {

    const theme = useTheme();

    const breadcrumbs = props.breadcrumbs?.map( (item, key) => {
        return (
            <Typography variant="button" sx={{display: "inline-block"}} key={key}>
                <Link to={item.link} style={{color:theme.palette.text.primary}}>{item.title}</Link>
                <Box sx={{width:4, height:4, backgroundColor:theme.palette.grey[700], mx:1, borderRadius:1, display:'inline-block', verticalAlign:'middle'}}></Box>                
            </Typography>
        )
    })

    if(props.loading) {
        return (
            <Stack spacing={1}>
                <Skeleton variant="rounded" height={28} />
                <Skeleton variant="rounded" height={22} />
            </Stack>
        )
    }

    return (
        <Stack spacing={1}>
            <Typography variant="h5" sx={{color: theme.palette.text.primary, fontWeight: 500}}>{props.title}</Typography>
            <Box>
                {breadcrumbs}
                <Typography variant="button" sx={{color: theme.palette.text.secondary, display: "inline-block"}}>{props.title}</Typography>
            </Box>
        </Stack>
    )
}